export const REQUEST_DASHBOARD = 'REQUEST_DASHBOARD'
export const REQUEST_DASHBOARD_LOADING = 'REQUEST_DASHBOARD_LOADING'
export const REQUEST_DASHBOARD_SUCCESS = 'REQUEST_DASHBOARD_SUCCESS'
export const REQUEST_DASHBOARD_FAILED = 'REQUEST_DASHBOARD_FAILED'
export const UPDATE_ALERT_COUNT = 'UPDATE_ALERT_COUNT'
export const ADD_ALERT_COUNT = 'ADD_ALERT_COUNT'